<template>
  <div class="car-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-input
            v-model="form.value"
            placeholder="请输入车牌号"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>
        <div class="right">
          <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="$router.push('/car/add')"
            v-hasPermi="['还车', '新增']"
            >增加车辆</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
      >
        <template>
          <el-table-column
            type="index"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="frame_num"
            label="车架号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tbox_num"
            label="TBOX编号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="work_num"
            label="车工号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="brand"
            label="车辆品牌"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="type"
            label="车辆型号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="maintenance_time"
            label="维护时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="model"
            label="车型"
            align="center"
          ></el-table-column>
          <el-table-column prop="car_status" label="租赁状态" align="center">
            <template slot-scope="{ row }">
              <span class="status" v-show="row.car_status == 1">已出租</span>
              <span class="status" v-show="row.car_status == 0">未出租</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px" align="center">
            <template slot-scope="scope">
              <div class="edit">
                <span
                  class="btn read"
                  v-if="scope.row.car_status == 0"
                  @click="
                    rentalClick(
                      scope.row.id,
                      0,
                      scope.row.frame_num,
                      scope.row.tbox_num
                    )
                  "
                  v-hasPermi="['还车', '租赁']"
                  >租赁</span
                >
                <span
                  class="btn read"
                  v-if="scope.row.car_status == 1"
                  @click="
                    rentalClick(
                      scope.row.id,
                      1,
                      scope.row.frame_num,
                      scope.row.tbox_num
                    )
                  "
                  v-hasPermi="['还车', '收回']"
                  >收回</span
                >
                <span
                  class="btn read"
                  @click="
                    readClick(
                      scope.row.id,
                      scope.row.frame_num,
                      scope.row.rent_company
                    )
                  "
                  v-hasPermi="['还车', '详情']"
                  >查看</span
                >
                <span
                  class="btn read"
                  @click="deleteClick(scope.row.id)"
                  v-hasPermi="['还车', '注销']"
                  >注销</span
                >
                <span
                  class="btn read"
                  @click="
                    rentalClick(
                      scope.row.id,
                      1,
                      scope.row.frame_num,
                      scope.row.tbox_num
                    )
                  "
                  v-hasPermi="['还车', '还车']"
                  >还车</span
                >
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>

      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="table.currentPage"
          :page-size="table.size"
          :total="table.total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增/编辑 -->
    <!-- <edit v-if="dialogVisible" @refresh="getData"/> -->
    <rental v-if="dialogVisible" />
    <!--<continues v-if="continueDialogVisible" />-->
  </div>
</template>

<script>
import { GetCarList, GetSortList, deleteLogicCar } from "@/api/car";
import { MessageBox } from "element-ui";
import rental from "./rental.vue";
// import continues from "./continue.vue";
export default {
  components: {
    rental
    // continues
  },
  data () {
    return {
      RoleId: sessionStorage.RoleId,
      dialogVisible: false,
      continueDialogVisible: false,
      form: {
        value: "",
        sort: "",
        rentSlstatus: "1"
      },
      childform: {
        id: "",
        type: ""
      },
      loading: false,
      options: [{ name: "默认", sort: "" }],
      rentSlstatus: [
        { name: "全部", car_status: "" },
        { name: "已租", car_status: "1" },
        { name: "未租", car_status: "0" }
      ],
      table: {
        data: [],
        height: 100,
        currentPage: 1,
        size: 50,
        total: 0
      }
    };
  },
  created () {
    this.getSortData();
    this.getData();
  },
  mounted () {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170;
      window.onresize = () => {
        this.table.height =
          window.innerHeight - this.$refs.table.offsetTop - 170;
      };
    });
  },
  methods: {
    refresh () {
      this.getData();
    },
    onChangeStripe () {
      this.search();
    },
    deleteClick (id) {
      MessageBox.confirm("此操作将注销该车辆的信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteLogicCare(id);
        })
        .catch(() => {
          this.$message("已取消注销");
        });
    },
    deleteLogicCare (id) {
      deleteLogicCar({ id }).then(res => {
        if (res.code === 0) {
          this.$message.success("注销成功!");
          this.refresh();
        } else {
          this.$message.err(res.message);
        }
      });
    },
    getSortData () {
      GetSortList().then(res => {
        this.options = this.options.concat(res.data);
      });
    },

    //获取列表信息
    getData () {
      this.loading = true;
      const params = { start: this.table.currentPage, size: this.table.size };
      this.form.sort ? (params.sort = this.form.sort) : "";
      params.car_status = this.form.rentSlstatus;
      this.form.value ? (params.frame_num = this.form.value) : "";
      GetCarList(params).then(res => {
        // console.log(res)
        this.loading = false;
        const data = res.data;
        this.table.data = data.content;
        this.table.total = data.total;
      });
    },
    search () {
      this.table.currentPage = 1;
      this.getData();
    },
    currentChange () {
      this.getData();
    },
    readClick (id, frame_num, rent_company) {
      this.$router.push({
        name: "CarDetail",
        query: { id, frame_num, rent_company }
      });
    },
    rentalClick (id, type, frame_num, tbox_num) {
      if (type === 1) {
        this.dialogName = "回收";
      } else if (type === 0) {
        this.dialogName = "租赁";
      }
      this.childform.id = id;
      this.childform.type = type;
      this.childform.frame_num = frame_num;
      this.childform.tbox_num = tbox_num;
      this.dialogVisible = true;
    },
    continueClick (id, type, frame_num, tbox_num) {
      this.dialogName = "续期";
      this.childform.id = id;
      this.childform.type = type;
      this.childform.frame_num = frame_num;
      this.childform.tbox_num = tbox_num;
      this.continueDialogVisible = true;
    }
  },
  filters: {
    status_f (val) {
      let res = "";
      switch (val) {
        case 0:
          res = "离线";
          break;
        case 1:
          res = "在线";
          break;
      }
      return res;
    }
  }
};
</script>

<style lang="less" scoped>
.car-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.car-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
